/* Aqua di Polo — koku testi.
   Seçenekler profil anahtarlarına oy verir; en çok oyu alan sonuç gösterilir.
   Eşitlikte ilk oyu alan kazanır (kullanıcının ilk yöneliminden yana). */
(function () {
  'use strict';

  function track(name, payload) {
    try {
      if (window.dataLayer && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: name }, payload || {}));
      }
      if (typeof window.gtag === 'function') window.gtag('event', name, payload || {});
    } catch (e) { /* ölçüm başarısız olsa da test çalışmaya devam eder */ }
  }

  function setup(root) {
    if (!root || root.dataset.adpQuizBound) return;
    root.dataset.adpQuizBound = '1';

    var intro = root.querySelector('[data-adp-quiz-intro]');
    var startBtn = root.querySelector('[data-adp-quiz-start]');
    var progress = root.querySelector('[data-adp-quiz-progress]');
    var stepEl = root.querySelector('[data-adp-quiz-step]');
    var fill = root.querySelector('[data-adp-quiz-fill]');
    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-adp-quiz-question]'));
    var results = Array.prototype.slice.call(root.querySelectorAll('[data-adp-quiz-result]'));
    if (!questions.length || !results.length) return;

    var answers = [];

    function hideAll() {
      if (intro) intro.hidden = true;
      questions.forEach(function (q) { q.hidden = true; });
      results.forEach(function (r) { r.hidden = true; });
    }

    function focusPanel(panel) {
      var h = panel.querySelector('h3');
      if (!h) return;
      h.setAttribute('tabindex', '-1');
      h.focus({ preventScroll: true });
    }

    function showQuestion(i) {
      hideAll();
      if (progress) progress.hidden = false;
      questions[i].hidden = false;
      if (stepEl) stepEl.textContent = (i + 1) + ' / ' + questions.length;
      if (fill) fill.style.width = ((i / questions.length) * 100) + '%';
      focusPanel(questions[i]);
    }

    /* Bazı sorular koku profiline oy vermez — cinsiyet sorusu gibi. Onların
       cevabı 'cinsiyet:kadin' biçiminde iki nokta içerir; sayıma katmıyoruz.
       Boş cevap da sayılmaz: eskiden boş profil 'fresh'e düşüyordu ve
       cinsiyet sorusu ferah kokulara sessizce oy veriyordu. */
    function oyVerirMi(p) { return !!p && p.indexOf(':') === -1; }

    function cinsiyet() {
      for (var i = 0; i < answers.length; i++) {
        if (answers[i] && answers[i].indexOf('cinsiyet:') === 0) {
          return answers[i].split(':')[1];
        }
      }
      return '';
    }

    function winner() {
      var tally = {};
      var order = [];
      answers.filter(oyVerirMi).forEach(function (p) {
        if (!(p in tally)) { tally[p] = 0; order.push(p); }
        tally[p] += 1;
      });
      var best = order[0];
      order.forEach(function (p) { if (tally[p] > tally[best]) best = p; });
      return best;
    }

    function showResult() {
      hideAll();
      if (progress) progress.hidden = true;
      var key = winner();
      var match = results.filter(function (r) {
        return r.getAttribute('data-adp-quiz-result') === key;
      })[0] || results[0];
      match.hidden = false;

      /* Cinsiyet cevabı sonucu değiştirmez ama gidilecek koleksiyonu daraltır:
         kadın seçildiyse kadın parfüm koleksiyonuna, erkek seçildiyse erkek
         koleksiyonuna, koku filtresi korunarak gidilir. */
      var c = cinsiyet();
      if (c) {
        var hedef = c === 'kadin' ? 'a-kadin-parfum' : (c === 'erkek' ? 'a-erkek-parfum' : '');
        if (hedef) {
          match.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
            if (a.getAttribute('data-adp-cinsiyet-uygulandi')) return;
            var h = a.getAttribute('href') || '';
            var yeni = h.replace(/\/collections\/[^/?#]+/, '/collections/' + hedef);
            a.setAttribute('href', yeni);
            a.setAttribute('data-adp-cinsiyet-uygulandi', '1');
          });
        }
      }

      /* Öneri listesi cinsiyete göre seçilir. Liquid kadın/erkek/genel için
         ayrı listeler basar; eşleşen yoksa genel liste açık kalır. */
      var listeler = match.querySelectorAll('[data-adp-picks]');
      if (listeler.length) {
        var istenen = c ? c : 'genel';
        var acilan = null;
        listeler.forEach(function (ul) {
          if (ul.getAttribute('data-adp-picks') === istenen) acilan = ul;
        });
        if (!acilan) {
          listeler.forEach(function (ul) {
            if (ul.getAttribute('data-adp-picks') === 'genel') acilan = ul;
          });
        }
        listeler.forEach(function (ul) { ul.hidden = ul !== acilan; });
      }

      var t = match.querySelector('.adp-quiz__result-title');
      if (t) { t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true }); }
      track('quiz_complete', { quiz: 'scent_finder', result: key, answers: answers.join(',') });
    }

    if (startBtn) {
      startBtn.addEventListener('click', function () {
        answers = [];
        track('quiz_start', { quiz: 'scent_finder' });
        showQuestion(0);
      });
    }

    questions.forEach(function (panel, i) {
      panel.querySelectorAll('[data-adp-quiz-answer]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          answers[i] = btn.getAttribute('data-adp-quiz-answer');
          answers.length = i + 1;
          if (i + 1 < questions.length) showQuestion(i + 1);
          else showResult();
        });
      });

      var back = panel.querySelector('[data-adp-quiz-back]');
      if (back) {
        back.addEventListener('click', function () {
          if (i === 0) return;
          answers.length = i;
          showQuestion(i - 1);
        });
      }
    });

    root.querySelectorAll('[data-adp-quiz-restart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers = [];
        hideAll();
        if (progress) progress.hidden = true;
        if (intro) intro.hidden = false;
        if (startBtn) startBtn.focus({ preventScroll: true });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-adp-quiz]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
